"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TrashIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M21.773,5.063H18.2V3.709A2.067,2.067,0,0,0,16.12,1.667H7.881A2.067,2.067,0,0,0,5.8,3.709V5.063H2.227v1.7H3.756V19.879a2.607,2.607,0,0,0,2.732,2.454H17.513a2.606,2.606,0,0,0,2.731-2.454V6.762h1.529ZM7.5,3.709a.367.367,0,0,1,.386-.343H16.12a.367.367,0,0,1,.386.343V5.063H7.5Zm11.05,16.17c0,.41-.473.755-1.032.755H6.488c-.56,0-1.032-.345-1.032-.755V6.762H18.545Z" }),
        react_1.default.createElement("rect", { x: "7.772", y: "11.279", width: "1.7", height: "5.54" }),
        react_1.default.createElement("rect", { x: "14.529", y: "11.279", width: "1.699", height: "5.54" }),
        react_1.default.createElement("rect", { x: "11.15", y: "9.899", width: "1.7", height: "8.3" })));
}
exports.default = TrashIcon;
